const h=(h,t)=>Math.min(t.width/h.width,t.height/h.height),t=(h,t)=>Math.max(t.width/h.width,t.height/h.height);export{t as findScaleToCover,h as findScaleToFit};
//# sourceMappingURL=findScaleTo.min.mjs.map
